import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';

const money = (v: any) =>
  Number(v || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 });

type Props = {
  cards: any;
};

class BudgetConsolidationCardsPanel extends React.Component<Props> {
  render() {
    const c = this.props.cards || {};

    const items = [
      ['Total Budget', money(c.totalbudget)],
      ['Activity Budget', money(c.activitybudget)],
      ['Direct Budget', money(c.directbudget)],
      ['Investment Budget', money(c.investmentbudget)],
      ['Cost Centers', c.costcenters || 0],
      ['Accounts', c.accounts || 0],
    ];

    return (
      <Grid container spacing={2}>
        {items.map(([label, value]) => (
          <Grid key={String(label)} size={{ xs: 12, sm: 6, md: 2 }}>
            <Card elevation={1}>
              <CardContent>
                <Typography variant="caption" color="text.secondary">
                  {label}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }
}

export default BudgetConsolidationCardsPanel;
